<template>
  <share-instance-modal :instance="instance">
    <template v-slot="{ on, attrs }">
      <v-chip
        v-if="shares"
        small
        v-on="on"
        @click.native.stop.prevent
        v-bind="attrs"
        color="info"
        :class="isSmall ? 'v-chip--small':''"
      >
        <v-icon :size="isSmall ? '12':'16'" color="white" class="mr-1">$shareIcon</v-icon>
        {{ shares }}
      </v-chip>
      <v-icon 
        v-else-if="showAssignText && isIcon" size="20" class="share-instance-btn"
        v-on="on"
        style="cursor: pointer"
      >
        $shareIcon
      </v-icon>
      <span
        v-else-if="showAssignText"
        v-on="on"
        class="label-bar-empty link-text p-4"
        style="cursor: pointer"
        >
        {{ $t('button.user.assign') }}
        </span>
    </template>
  </share-instance-modal>
</template>

<script>
import ShareInstanceModal from "../modal/ShareInstanceModal.vue";

export default {
  props: {
    instance: Object,
    showAssignText: Boolean,
    isSmall: Boolean,
    isIcon: Boolean,
  },
  components: {
    ShareInstanceModal,
  },
  computed: {
    shares() {
      return this.instance.sharedAccess.length;
    },
  },
};
</script>

<style lang="scss" scoped>
.v-chip {
  border-radius: 4px;
  font-size: $font-size-xxs;
  line-height: $line-height-xxs;
  color: white;
  font-weight: $font-weight-semibold;
  padding: 4px 8px;
  height: 28px;
  &--small{
      width: 37px;
      max-width: 37px;
      padding: 4px 4px;
      height: 24px;
  }
  &:active,
  &:focus{
      box-shadow: none;
  }
}


</style>